import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ArticleTypeAdminComponent } from './components/article-type-admin/article-type-admin.component';

const routes: Routes = [
  {
    path: '', component: ArticleTypeAdminComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArticleTypeRoutingModule { }
